import type { IntlShape } from '@umijs/max';

/** 判断字符串是否包含中文（CJK 统一汉字） */
export function containsChinese(text: string): boolean {
  return /[\u4e00-\u9fff]/.test(text);
}

/** 当前 locale 是否为中文（zh-CN / zh-TW 等） */
export function localeIsChinese(locale: string | undefined): boolean {
  return String(locale || '').toLowerCase().startsWith('zh');
}

/**
 * 解析 branding.json 中的文案：非中文语言下若值为中文，则回退到 i18n 译文。
 */
export function resolveBrandingText(
  intl: Pick<IntlShape, 'locale'>,
  brandingValue: string | undefined,
  i18nFallback: string,
): string {
  const raw = String(brandingValue ?? '').trim();
  if (!raw) return i18nFallback;
  if (!localeIsChinese(intl.locale) && containsChinese(raw)) {
    return i18nFallback;
  }
  return raw;
}
